(function () {
    var nav, touchEnabled, activeMenu, timer, MENU_TIMEOUT = 300, openMenu = function (ev) {
        var item = ev.currentTarget, subMenu = item.getElementsByTagName("div")[0];
        item.classList.add("hover");
        closeMenu();
        activeMenu = subMenu;
    }, closeMenu = function (ev) {
        var item = ev ? ev.currentTarget : (activeMenu ?  activeMenu.parentNode : undefined);
        if (item) {
            item.classList.remove("hover");
        }
        activeMenu = null;
    };
    try {
        touchEnabled = 'createTouch' in document || window.navigator.msPointerEnabled;
        if (touchEnabled) {
            nav = document.querySelectorAll(".site-nav > ul > li");
            if (window.navigator.msPointerEnabled) {
                Array.prototype.forEach.call(nav, function (item) {
                    item.addEventListener("MSPointerOver", openMenu, false);
                    item.addEventListener("MSPointerOut", closeMenu, false);
                    document.body.addEventListener("MSPointerOver", closeMenu, false);
                });
            } else {
                Array.prototype.forEach.call(nav, function (item) {
                    item.addEventListener("touchstart", openMenu, false);
                    item.addEventListener("touchend", closeMenu, false);
                    document.body.addEventListener("touchstart", closeMenu, false);
                });
            }
        }
    } catch (e) {
        if (console) { console.error(e); }
    }
}());


// WEBPACK FOOTER //
// ./Content/js/menus.js